import {createSlice, PayloadAction} from '@reduxjs/toolkit'

import {Overlay} from './types'

export type OverlayStateType = {
  activeOverlay: null | string
  overlays: Overlay[]
}

export const initialState: OverlayStateType = {
  activeOverlay: null,
  overlays: []
}

const {actions, reducer} = createSlice({
  name: 'overlay',
  initialState,
  reducers: {
    hideOverlay: state => {
      if (state.activeOverlay) history.back()
    },
    setOverlayState: (state, {payload}: PayloadAction<OverlayStateType>) => {
      const {activeOverlay, overlays} = payload

      if (
        !activeOverlay ||
        overlays.length === 0 ||
        !overlays.find(o => o.id === activeOverlay)
      ) {
        return initialState
      }

      return payload
    },
    updateActiveOverlayState: (state, {payload}) => {
      const {overlays} = state
      const activeOverlayIndex = overlays.findIndex(
        o => o.id === state.activeOverlay
      )

      if (activeOverlayIndex === -1) {
        return initialState
      }

      overlays[activeOverlayIndex] = {
        ...overlays[activeOverlayIndex],
        ...payload
      }
    }
  }
})

export default reducer

export const {hideOverlay, setOverlayState, updateActiveOverlayState} = actions
